<template>
  <MglMarker
    :coordinates="coordinates"
    @added="$emit('added', $event)"
    @removed="$emit('removed', $event)"
    @click="
      () => {
        if ($mq === 'sm') $emit('click', dataset);
      }
    "
  >
    <div slot="marker">
      <MapPin style="transform: scale(3)" />
      <div v-if="ordinal" class="ordinal-dot">{{ ordinal }}</div>
    </div>
    <MglPopup :offset="48" :closeButton="false" @open="onOpen">
      <div>
        <div class="popup-header">
          <MapPin class="popup-icon" />
          <div>
            <div class="popup-header-title">{{ dataset.name }}</div>
            <address class="hospital-address">{{ address }}</address>
          </div>
        </div>
        <HospitalDetail :hospitalData="dataset" />
      </div>
    </MglPopup>
  </MglMarker>
</template>

<script>
import HospitalDetail from '@/components/ResultsMap/hospital-detail';
import MapPin from '@/assets/map-pin.svg';
import centerMapOnPopup from '@/util/centerMapOnPopup';
import getAddress from '@/util/getAddress';
import { MglMarker, MglPopup } from 'vue-mapbox';

export default {
  components: {
    HospitalDetail,
    MapPin,
    MglMarker,
    MglPopup,
  },
  props: {
    ordinal: {
      type: Number,
      default: null,
    },
    dataset: {
      type: Object,
      required: true,
    },
  },
  computed: {
    coordinates() {
      return [this.dataset.location.lng, this.dataset.location.lat];
    },
    address() {
      return getAddress(this.dataset.location);
    },
  },
  methods: {
    onOpen(event) {
      const { map, popup } = event;
      centerMapOnPopup(map, popup);
      this.$emit('popupOpen', popup);
    },
  },
};
</script>

<style scoped>
.hospital-address {
  color: #a9a9a9;
  display: block;
  font-size: 13px;
  font-style: normal;
}

.marker {
  color: var(--black);
}

.ordinal-dot {
  align-items: center;
  background-color: var(--off-white);
  border: 2px solid var(--black);
  border-radius: 10px;
  display: flex;
  font-size: 8px;
  font-weight: bold;
  height: 18px;
  justify-content: center;
  left: 6px;
  position: absolute;
  top: -16px;
  width: 18px;
}

.popup-header {
  align-items: flex-start;
  border-bottom: 1px solid var(--off-white);
  display: flex;
  font-size: 15px;
  padding-bottom: 8px;
}

.popup-header-title {
  font-size: 16px;
  line-height: 1.2em;
}

.popup-icon {
  flex-shrink: 0;
  margin-right: 8px;
  margin-top: 4px;
}
</style>
